import React, { useEffect } from 'react';
import './DistributorsPage.css';
import { optimizeImage } from '../utils/imageOptimizer';
import { FaMapMarkerAlt } from 'react-icons/fa';

const DistributorsPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="distributors-page-container">
            <div className="distributor-bg-wrapper">
                <picture>
                    <source media="(max-width: 768px)" srcSet={optimizeImage("https://caninecrown.ascentbw.com/Image/BgmobDistribu.png")} />
                    <img 
                        src={optimizeImage("https://caninecrown.ascentbw.com/Image/BgdesDistribut.png")} 
                        alt="Background Map and Dog" 
                        className="distributor-bg-img"
                        loading="eager"
                    />
                </picture>
            </div>
            
            <div className="distributor-content-overlay">
                <div className="distributor-content-card">
                    <div className="distributor-tag">
                        <FaMapMarkerAlt className="distributor-tag-icon" />
                        <span>DISTRIBUTOR NETWORK</span>
                    </div>
                    <h1 className="distributor-title">
                        Coming <span className="text-red">Soon!</span>
                    </h1>
                    <p className="distributor-description">
                        We're working hard to build a strong network of trusted distributors across India.
                    </p>
                    <p className="distributor-stay-tuned">
                        Stay tuned for updates!
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DistributorsPage;

